<template>
  <div id="app">
    <el-container>
      <el-header>蓉戎超市投诉处理平台</el-header>
      <el-main>
        <el-form ref="form" :model="form" label-position="right" size="small" label-width="100px">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="投诉时间">
                <el-date-picker
                    v-model="form.time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="投诉门店" prop="storeCode">
                <el-select v-model="form.storeCode" placeholder="请选择" filterable clearable>
                  <el-option
                      v-for="item in storeOptions"
                      :key="item.storeCode"
                      :label="item.storeName"
                      :value="item.storeCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="投诉类型" prop="type">
                <el-select v-model="form.type" clearable>
                  <el-option label="投诉" value="1"></el-option>
                  <el-option label="建议" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="是否重复投诉">
                <el-select v-model="form.isRepeated" clearable>
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="是否展示">
                <el-select v-model="form.isDisplay" clearable>
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-form-item label="是否处理">
                <el-select v-model="form.isHandle" clearable>
                  <el-option label="是" :value="true"></el-option>
                  <el-option label="否" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="text-align: center">
              <el-form-item>
                <el-button type="primary" @click="query">查询</el-button>
                <el-button type="primary" @click="onBack">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
            stripe
            :data="tableData"
            @cell-dblclick="cellDbClick"
            style="width: 100%">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
              <el-table-column prop="name" label="投诉人姓名"></el-table-column>
              <el-table-column prop="type" label="投诉类型">
                  <template slot-scope="scope">
                      <el-tag
                              :type="scope.row.type === '0' ? 'success' : 'danger'"
                              disable-transitions>{{ scope.row.type === '0' ? '建议' : '投诉' }}
                      </el-tag>
                  </template>
              </el-table-column>
              <el-table-column prop="phone" label="手机号"></el-table-column>
              <el-table-column prop="storeName" label="投诉门店"></el-table-column>
              <el-table-column prop="time" label="投诉时间"></el-table-column>
              <el-table-column prop="isRepeated" label="是否重复投诉">
                <template slot-scope="scope">
                  <el-tag
                      :type="scope.row.isRepeated === true ? 'success' : 'danger'"
                      disable-transitions>{{ scope.row.isRepeated === true ? '是' : '否' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="isDisplay" label="是否展示">
                <template slot-scope="scope">
                  <el-tag
                      :type="scope.row.isDisplay === true ? 'success' : 'danger'"
                      disable-transitions>{{ scope.row.isDisplay === true ? '是' : '否' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="isHandle" label="是否处理">
                <template slot-scope="scope">
                  <el-tag
                      :type="scope.row.isHandle === true ? 'success' : 'danger'"
                      disable-transitions>{{ scope.row.isHandle === true ? '是' : '否' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="handleTime" label="处理时间"></el-table-column>
            </el-col>
          </el-row>
        </el-table>
        <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            :current-page.sync="page"
            layout="->,total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
        >
        </el-pagination>
      </el-main>
      <el-footer>
        <el-button type="primary" @click="onBack" style="text-align: center">返回</el-button>
      </el-footer>
    </el-container>

    <el-drawer
        title="投诉内容"
        size="100%"
        :destroy-on-close="true"
        :visible.sync="drawer"
        direction="ttb"
        :before-close="handleClose">
      <ComplaintHandle :id="id" @handleClose="handleClose"></ComplaintHandle>
    </el-drawer>
  </div>
</template>

<script>

import ComplaintHandle from './ComplaintHandle.vue'

export default {
  name: 'App',
  components: {
    ComplaintHandle
  },
  data() {
    return {
      form: {},
      storeOptions: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      drawer: false,
      id: ''
    }
  },
  created() {
    this.init()
    this.getComplaintStoreList()
  },
  methods: {
    onBack() {
      this.$router.push('/')
    },
    getComplaintStoreList() {
      this.$http.get('/complaintStore').then(res => {
        if (String(res.code) === '1') {
          this.storeOptions = res.data
        }
      }).catch(() => {
        return this.$message.error("获取门店数据失败")
      })
    },
    async init() {
      this.form.pageSize = this.pageSize
      this.form.page = this.page
      const res = await this.$http.post('/page', this.form)
      if (String(res.code) === '1') {
        this.tableData = res.data.records || []
        this.total = res.data.total
      } else {
        return this.$message.error('系统繁忙,请稍后再试')
      }
    },
    query() {
      this.init();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page = val
      this.init()
    },
    cellDbClick(row) {
      this.drawer = true
      this.id = row.id
    },
    handleClose() {
      this.drawer = false
    }
  }
}
</script>

<style>
.el-container {
  height: 100%;
}

.el-header, .el-footer {
  text-align: center;
  background: #fff;
  line-height: 60px;
}

.el-date-editor.el-input {
  width: 100%;
}

.el-range-editor--small.el-input__inner {
  width: 100%;
}

.el-select {
  width: 100%;
}

.el-card {
  height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/components/ComplaintQuery.vue